<template>
  <span :class="value" class="mu-icon" :style="{'font-size': size + 'px', color: color, fontWeight: weight? 'bold': 'normal'}" @click="$emit('click')"></span>
</template>
<script>
export default {
  name: 'MuIcon',
  props: {
    value: {
      type: String
    },
    size: {
      type: [Number, String],
      default: 12
    },
    color: {
      type: String
    },
    weight: {
      type: Boolean
    }
  }
}
</script>
